import React from "react";

const Section2 = () => {
  return (
    <div className="w-full bg-white Section2 py-[50px] md:py-[50px]">
      {/* Hero Content */}
      <div className="w-[90%] md:w-[85%] mx-auto flex flex-col md:flex-row items-center justify-between gap-10">

        {/* Left Content */}
        <div className="w-full md:w-1/2 text-center md:text-left">
          <h1 className="text-[26px] md:text-[34px] font-bold text-[#000] -mt-10 md:mt-[0] leading-[34px] md:leading-[38px] mb-6">
            Top Web Development Agency in New York
          </h1>

          <p className="text-[15px] md:text-[18px] text-[#444444] leading-[26px] mb-6 max-w-[500px] mx-auto md:mx-0">
            At Mean3, we're a trusted, results-driven web development company based in New York, serving over 300 clients across startups, SMEs, and enterprise brands. We specialize in building fast, scalable, and conversion-optimized websites using the latest technologies, including React, Laravel, Shopify, and Magento. With deep local insight and global standards, we deliver innovative, secure, and SEO-ready digital experiences tailored to your business goals.
          </p>

          <p className="text-[15px] md:text-[18px] text-[#444444] leading-[26px] mb-10 max-w-[500px] mx-auto md:mx-0">
            Whether you need a powerful custom web app, a Shopify-powered ecommerce store, or a Magento site, our expert team helps turn your ideas into high-performing solutions designed to drive growth.
          </p>

          <div className="flex flex-col sm:flex-row gap-4 justify-center md:justify-start">
            <a
              href="https://mean3.com/contact-mean3"
              className="bg-[#DA2128] hover:bg-[#b71c22] text-white text-[14px] md:text-[16px] font-semibold px-6 py-3 rounded-[8px] transition-all duration-300 inline-block text-center"
            >
              Get a Free Consultation
            </a>
          </div>

        </div>

        {/* Right Image */}
        <div className="w-full md:w-1/2 flex justify-center">
          <img
            src="/assets/nyc.png"
            alt="New York Web Development Agency"
            className="w-[90%] md:w-[80%] max-w-[500px] h-auto"
          />
        </div>
      </div>
    </div>
  );
};

export default Section2;
